import React, { useEffect, useState } from "react";
import Modal from "../../components/Modal";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Icon } from "@material-ui/core";
import ButtonCustom from "../../components/ButtonCustom";
import CustomTypo from "../../components/CustomTypo";
import { CloseIcon } from "../../components/icons";
import { getAppCfg } from "../../utils/common";
import crmservices from "../../wsclient/crmservices";
import { Field, Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { SelectComponent, TextAreaComponent } from "../../components/FormElement";
import validators from "../../utils/validators";
import ModalAlert from "../../components/ModalAlert";
import Loading from "../../components/Loading";

const SR_QUEUE_NAME = "DOWNGRADE"

export default function FormServiceChange(props) {
    const { open, onClose } = props;
    const [active, setActive] = useState('main');
    const [queues, setSRQueues] = useState([]);
    const [request_info, setRequestInfo] = useState({});
    const [message, setMessage] = useState(null);
    const [showLoading, setShowLoading] = useState(false);

    let appConfig = getAppCfg();

    useEffect(() => {
        loadData();
    }, [])

    const loadData = async () => {
        await getSRQueue();
    }

    const getSRQueue = async () => {
        try {
            let result = await crmservices.config.getQueues();
            if (result.code == 'OK' && result.data) {
                let queue = result.data?.content?.find(x => x.name && x.name.toUpperCase() === SR_QUEUE_NAME);
                if (queue) {
                    setSRQueues([{ label: queue.name, value: queue.id }])
                    setRequestInfo(prevState => ({
                        ...prevState,
                        queue_id: queue.id,
                    }))
                }
            }
        } catch (error) {
            console.log("AAAA getSRQueue error: ", error)
        }
    }

    const onCreateSR = async (values) => {
        setShowLoading(true)
        try {
            let result = await crmservices.config.createServiceRequest({
                queue_id: request_info.queue_id,
                description: values.description,
            });
            if (result.code == 'OK') {
                showMessage({ status: true, message: t('create_service_request_success'), callback: props.onCloseAfterSuccess })
            } else {
                showMessage({ status: true, message: t('create_service_request_failed') })
            }
        } catch (error) {
            console.log("AAAA onCreateSR error: ", error)
            showMessage({ status: true, message: t('EXCEPTION_PROCESS') })
        }
        setShowLoading(false)
    }

    const showMessage = ({ status, message, callback }) => {
        setShowLoading(false);
        setMessage({
            show: true,
            message: message,
            status: status,
            onClose: callback ? callback : () => setMessage(null)
        })
    }

    const onSpeakToAgent = () => {
        console.log("AAAA onSpeakToAgent")
        let link = document._portalConfig.speakAgentLink;
        if (link) window.open(link);
    }

    const { t } = useTranslation();
    return (
        <>
            {showLoading && <Loading showLoading={showLoading} />}
            <Dialog open={open} onClose={onClose} fullWidth={true}>
                <DialogTitle style={{ borderBottom: '1px solid #ccc' }}>
                    <Grid container direction='row'>
                        <Grid item xs={10}>
                            <CustomTypo variant="h5">{"Change service"}</CustomTypo>
                        </Grid>
                        <Grid item xs={2} onClick={onClose} style={{ textAlign: 'right', float: 'right' }}>
                            <Icon style={{ cursor: 'pointer' }}>
                                <CloseIcon color={'#333'} />
                            </Icon>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent style={{ padding: 15 }}>
                    {active == 'main' && <Grid item xs={12} container alignContent="center" justifyContent="center">
                        {/* {props.content ? <CustomTypo variant="subtitle1" color={'error'} mg_top_md mg_bottom_md>{props.content}</CustomTypo> : <></>} */}
                        <CustomTypo variant="subtitle1">Would you like to raise a service request or speak to an agent for assistance?</CustomTypo>
                        <div style={{ marginTop: '20px' }}>
                            {/* <div onClick={() => setActive('service_request')} style={{ border: '1px solid #ccc', padding: '10px 20px', borderRadius: 4, cursor: 'pointer' }}>
                                <CustomTypo variant="subtitle1">Raise Service Request</CustomTypo>
                            </div>
                            <div onClick={() => onSpeakToAgent()} style={{ border: '1px solid #ccc', padding: '10px 20px', borderRadius: 4, marginTop: 10, cursor: 'pointer' }}>
                                <CustomTypo variant="subtitle1">Speak to an Agent</CustomTypo>
                            </div> */}
                            <ButtonCustom size="sm" fullWidth color={'primary'} onClick={() => setActive('service_request')}>Raise Service Request</ButtonCustom>
                            <ButtonCustom size="sm" fullWidth color={'primary'} onClick={() => onSpeakToAgent()}>Speak to an Agent</ButtonCustom>
                        </div>
                    </Grid>}
                    {active == 'service_request' && <>
                        <Form
                            onSubmit={onCreateSR}
                            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                                <Grid xs={12} container item justifyContent='center'>
                                    <Grid xs={12} item container>
                                        <Field
                                            name="classification_id"
                                            component={SelectComponent}
                                            label={t('classification')}
                                            selectData={queues}
                                            defaultValue={request_info?.queue_id}
                                            valueSelect={request_info?.queue_id}
                                            color='default'
                                            placeholder={t('Select')}
                                            isEdit={false}
                                        />
                                    </Grid>
                                    <Grid xs={12} item container>
                                        <Field
                                            name="description"
                                            component={TextAreaComponent}
                                            label={t('description')}
                                            isEdit={true}
                                            color='default'
                                            labelColor='default'
                                            defaultValue={request_info?.description}
                                            multiline
                                            validate={validators.composeValidators(validators.required)}
                                        />
                                    </Grid>
                                    <Grid xs={12} item container style={{ marginTop: 10 }}>
                                        <ButtonCustom color='primary' fullWidth onClick={handleSubmit}>{t('btn_submit')}</ButtonCustom>
                                    </Grid>
                                </Grid>
                            )} />
                    </>}
                </DialogContent>
                <DialogActions></DialogActions>
            </Dialog>
            {message && message.show && <ModalAlert
                open={message.show}
                hideHeader={true}
                message={message.message}
                error={message.status}
                title={message.title}
                onClose={message.onClose}
            />}
        </>
    )
}